import {FC} from "react";
import {Link} from "react-router-dom";


import SectionContent from "../../../components/sectionContent/sectionContent";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import ContractsList from "../../../pages/contracts/contractsList/contractsList";


const CustomerContractsListSection: FC = () => {

    return (
        <div className="App">
            <Sidebar/>
            <SectionContent
                section="Контракты"
                pageName="contracts"
                title="Список контрактов">
                <div className="content__main">
                    <div className="btns">
                        <Link to="/contracts" className="tab">
                            <div className="buttons__btn --active">Мерчендайзинг</div>
                        </Link>
                    </div>
                    <ContractsList/>
                </div>
            </SectionContent>
        </div>
    );
};

export default CustomerContractsListSection;